/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Forward_One_SecondInputs */



/**
* | output |
* | --- |
* | "Forward 1 Second" |
*
* @param {Shortcut_Keys_Name_Forward_One_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_forward_one_second = /** @type {((inputs?: Shortcut_Keys_Name_Forward_One_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Forward_One_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer d'une seconde")
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Sekunde vorwärts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanti di 1 secondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотать на 1 секунду вперед")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar 1 segundo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前进 1 秒")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1 सेकंड आगे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avançar 1 segundo")
	return /** @type {LocalizedString} */ ("Forward 1 Second")
});